import { render, staticRenderFns } from "./VesselMovementMap.vue?vue&type=template&id=f08aafe6&scoped=true&"
import script from "./VesselMovementMap.vue?vue&type=script&lang=js&"
export * from "./VesselMovementMap.vue?vue&type=script&lang=js&"
import style0 from "./VesselMovementMap.vue?vue&type=style&index=0&id=f08aafe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08aafe6",
  null
  
)

export default component.exports